exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mb-pagination[data-v-5a21b7f1]{display:grid;grid-template-columns:1fr auto 1fr}", ""]);

// exports
